import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "reactstrap";
import dayjs from "dayjs";
import { Pill } from "./RutasTable";
import { agoColor, agoTxt, estadoPorMinutos, hora, minutosDesde } from "./estados";

/** Salidas en curso de la ruta seleccionada, la mas atrasada primero. */
const RutaDetail = ({ ruta, salidas, now, loading }) => {
  if (!ruta) return null;

  const trips = (salidas ?? [])
    .map((s) => {
      const min = minutosDesde(s.last_update, now) ?? 0;
      const st = estadoPorMinutos(min);
      return {
        id: s.id,
        unit: s.unit_name ?? "—",
        op: s.operator_name ?? "—",
        dep: dayjs(s.date).format("HH:mm"),
        ramal: s.ramal_nombre,
        geo: s.last_geofence ?? "Sin checkpoints aún",
        progress: `${s.passed} de ${s.total} geocercas`,
        lastTime: hora(s.last_update, now),
        ago: agoTxt(min),
        min,
        st,
      };
    })
    .sort((a, b) => b.min - a.min);

  let emptyMsg = "Todas las salidas iniciadas ya finalizaron.";
  if (ruta.salidas === 0) emptyMsg = "No tiene salidas programadas hoy.";
  else if (ruta.st === "nodata") emptyMsg = `Tiene ${ruta.salidas} salidas programadas hoy y ninguna ha iniciado.`;

  return (
    <section className="ms-card">
      <div className="ms-detail-head">
        <span className="ms-eyebrow">Salidas en curso · {ruta.cliente}</span>
        <h2>{ruta.name}</h2>
        <span className="ms-detail-meta">
          <Pill st={ruta.st} />
          Última actualización {ruta.lastTime} · {ruta.ago}
          {loading && <Spinner size="sm" />}
        </span>
      </div>
      {trips.length > 0 ? (
        <div className="ms-scroll-x">
          <div style={{ minWidth: 860 }}>
            <div className="ms-grid-salidas ms-thead">
              <span>Unidad</span>
              <span>Operador</span>
              <span>Salida</span>
              <span>Última geocerca</span>
              <span>Última actualización</span>
              <span>Estado</span>
            </div>
            {trips.map((t) => (
              <div className="ms-grid-salidas ms-trip-row" key={t.id}>
                <span className="ms-mono" style={{ fontWeight: 700 }}>{t.unit}</span>
                <span>{t.op}</span>
                <span style={{ display: "flex", flexDirection: "column" }}>
                  <span className="ms-mono">{t.dep}</span>
                  {t.ramal && <span style={{ fontSize: 12, color: "#5c5c64" }}>{t.ramal}</span>}
                </span>
                <span style={{ color: "#3d3d43" }}>
                  {t.geo} <span style={{ color: "#5c5c64" }}>· {t.progress}</span>
                </span>
                <span className="ms-ago">
                  <span className="ms-mono">{t.lastTime}</span>
                  <span style={{ color: agoColor(t.st) }}>{t.ago}</span>
                </span>
                <span>
                  <Pill st={t.st} />
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="ms-detail-empty">
          <span>{salidas === null ? "Cargando salidas…" : "No hay salidas en curso en esta ruta."}</span>
          {salidas !== null && <span>{emptyMsg}</span>}
        </div>
      )}
    </section>
  );
};

RutaDetail.propTypes = {
  ruta: PropTypes.object,
  salidas: PropTypes.array,
  now: PropTypes.string,
  loading: PropTypes.bool,
};

export default RutaDetail;
